var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import * as S from './style-1';
import Image from '../../../components/loggedout/common/Image';
import { fetchImageUrlForNewOnboarding, getItemFromLocalStorage, setItemInLocalStorage } from '../../../utils/web-helper';
import { GetLoadThroughScreenData } from '../../../services/loggedout-api';
import useExtendedLocalStorage from '../../common/hooks/useExtendedLocalStorage';
import { ELEMENTARY_SCHOOL_PROGRAM, PRE_K_GRADE } from '../../../constant-data/constants';
export var LoadThroughScreenOne = function (props) {
    var childName = getItemFromLocalStorage('tutoringChildName');
    var selectedPersonalize = (getItemFromLocalStorage('splashverse-onboarding') || { selectedPersonalize: '' }).selectedPersonalize;
    var isSelectedPersonalizeYes = selectedPersonalize == 'yes_personalize';
    var _a = useState([]), loadThroughScreen1Data = _a[0], setLoadThroughScreen1Data = _a[1];
    var _b = useState(false), isDataLoaded = _b[0], setDataLoaded = _b[1];
    var getItem = useExtendedLocalStorage('splashverse-onboarding', '').getItem;
    var selectedAge = getItem('selectedAge');
    var selectedGrade = getItem('selectedGrade');
    var interval1;
    var interval2;
    useEffect(function () {
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadData()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () { return clearAllTimeouts(); };
    }, []);
    var clearAllTimeouts = function () {
        clearInterval(interval1);
        clearInterval(interval2);
    };
    var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            try {
                response = GetLoadThroughScreenData({}).then(function (res) {
                    var screen1Response = res.loadthrough_screen_1;
                    var screen3Response = res.loadthrough_screen_3;
                    var screen1ResponseFiltered = [2, 3, 4].map(String).includes(String(selectedAge)) ? screen1Response.pk[selectedAge] : screen1Response[selectedGrade];
                    var screen3ResponseFiltered = [2, 3, 4].map(String).includes(String(selectedAge)) ? screen3Response.pk : screen3Response[selectedGrade];
                    var selectedProgram = getItem('selectedProgram');
                    var screen1ResponseFilteredLength;
                    if (selectedProgram == ELEMENTARY_SCHOOL_PROGRAM && selectedGrade == PRE_K_GRADE) {
                        setLoadThroughScreen1Data(screen1ResponseFiltered['3']);
                        screen1ResponseFilteredLength = screen1ResponseFiltered['3'].length;
                    }
                    else {
                        setLoadThroughScreen1Data(screen1ResponseFiltered);
                        screen1ResponseFilteredLength = screen1ResponseFiltered === null || screen1ResponseFiltered === void 0 ? void 0 : screen1ResponseFiltered.length;
                    }
                    setDataLoaded(true);
                    var screen3ResponseObject = {
                        "loadthrough-screen-3": screen3ResponseFiltered
                    };
                    setItemInLocalStorage('loadthrough-screen-3', screen3ResponseObject);
                    var _loop_1 = function (i) {
                        interval1 = setTimeout(function () {
                            var column = document.getElementById("column-".concat(i));
                            column === null || column === void 0 ? void 0 : column.classList.add('apply-animation');
                        }, i * 1000);
                    };
                    for (var i = 0; i < screen1ResponseFilteredLength; i++) {
                        _loop_1(i);
                    }
                    interval2 = setTimeout(function () {
                        props.goToNextHandler('load_through_screen_1', {});
                    }, (screen1ResponseFilteredLength * 1000) + 4000);
                });
            }
            catch (e) {
                console.error(e);
            }
            return [2 /*return*/];
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Heading, null, isSelectedPersonalizeYes ?
            'Finishing up with more exciting resources'
            :
                "Hold on, we're setting up ".concat(childName, "'s library...")),
        React.createElement(S.SubHeading, null, "Adding 4,000+ skills"),
        isDataLoaded &&
            React.createElement(S.LibrarySlideTilesWrapper, null, loadThroughScreen1Data && loadThroughScreen1Data.map(function (data, index) { return (React.createElement(S.LibrarySlideColumn, { key: index, id: "column-".concat(index) },
                React.createElement(S.LibraryTitle, { bgColor: data.titleBGColor }, data.title),
                React.createElement(S.CGSlideOne, { bgColor: data.tileBGColor },
                    React.createElement(S.CGImage, null,
                        React.createElement(Image, { src: fetchImageUrlForNewOnboarding(data.firstCGPath, data.firstCGImage), alt: "letter-tracing" })),
                    React.createElement(S.CGText, { textColor: data.titleBGColor }, data.firstCGName)),
                React.createElement(S.CGSlideTwo, { bgColor: data.tileBGColor },
                    React.createElement(S.CGImage, null,
                        React.createElement(Image, { src: fetchImageUrlForNewOnboarding(data.secondCGPath, data.secondCGImage), alt: "letter-tracing" })),
                    React.createElement(S.CGText, { textColor: data.titleBGColor }, data.secondCGName)))); }))));
};
export default LoadThroughScreenOne;
